/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { useDispatch } from "react-redux";
import { App } from "../../api/apiCalls";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";
import Modal from "react-bootstrap/Modal";

interface UnsubscriptionModalProps {
  app: App | undefined;
}

function UnsubscriptionModal({ app }: UnsubscriptionModalProps) {
  const dispatch = useDispatch();
  const mainPageData = useMainPageDataSelector();

  const unsubscribingAction = () => {
    const subReq = {
      appId: app?.appId,
      msisdn: mainPageData.appUser?.msisdn,
      action: 0,
    };
    dispatch({
      type: MainPageEvent.UNSUBSCRIBE,
      payload: subReq,
      token: mainPageData.authToken ? mainPageData.authToken : null,
    });
  };

  const hideUnsubscriptionModalAction = () => {
    dispatch({
      type: MainPageEvent.HIDE_UNSUBSCRIPTION_MODAL,
    });
  };

  return (
    <Modal
      show={mainPageData.showUnsubscriptionModal}
      onHide={() => {
        hideUnsubscriptionModalAction();
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Unsubscribe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="sub-text">
          Are you sure you want to unsubscribe to {app?.name}?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            hideUnsubscriptionModalAction();
          }}
        >
          Close
        </button>
        <button
          disabled={mainPageData.subscribing}
          className="btn btn-primary"
          type="button"
          data-toggle="modal"
          data-target="#verify-otp-modal"
          onClick={() => unsubscribingAction()}
        >
          <i
            className={
              mainPageData.subscribing ? "fas fa-spin fa-circle-notch" : ""
            }
          ></i>
          {mainPageData.subscribing ? "Unsubscribing..." : "Unsubscribe"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default UnsubscriptionModal;
